module.exports = __webpack_public_path__ + "img/usiminas-logo-1.f60f56eb.png";